export default {"src":"/_next/static/media/3.2-h.655ffc7a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};